import { ARENA_ART_W, ART_W, WORLD_TO_ART } from "../shared/screen";
import type { MatchState } from "../sim";

/** Камера доезжает до цели за ~0,3 с: желаемая скорость — доля оставшегося пути (замедление к концу). */
const FOLLOW = 4;
/** Предел скорости и разгона, пикселей арта за кадр (и за кадр²): рывков нет ни на скачке, ни на бросках. */
const MAX_SPEED = 12;
const MAX_ACCEL = 2.5;
/** Хвост подъезда — не медленнее этого: без долгого «доползания» последних пикселей. */
const MIN_SPEED = 1;

/**
 * Камера в пикселях арта: середина между бойцами. Едет плавно — с ограниченными скоростью и разгоном, тормозит к цели
 * (Джон 04.11.2026: «дёргание камеры в этот момент мешает» — на скачке середина пары прыгает). На экран — только целые
 * пиксели: не дрожит и не мерцает (docs/design/art-pipeline.md, правила читаемости).
 */
export class Camera {
  x = (ARENA_ART_W - ART_W) / 2;
  private position = this.x;
  private speed = 0;

  /** Где боец для камеры, пиксели мира: на скачке — центр облака частиц, а не скрытое тело (renderer). */
  focus: [number | null, number | null] = [null, null];

  private target(state: MatchState): number {
    const a = this.focus[0] ?? state.fighters[0].x / 256;
    const b = this.focus[1] ?? state.fighters[1].x / 256;
    const middle = ((a + b) / 2) * WORLD_TO_ART;
    return Math.round(Math.min(Math.max(middle - ART_W / 2, 0), ARENA_ART_W - ART_W));
  }

  update(state: MatchState): void {
    const gap = this.target(state) - this.position;
    const share = gap / FOLLOW;
    const wanted = Math.sign(gap) * Math.min(MAX_SPEED, Math.max(Math.abs(share), Math.min(MIN_SPEED, Math.abs(gap))));
    this.speed += Math.max(-MAX_ACCEL, Math.min(MAX_ACCEL, wanted - this.speed));
    // не перелетать цель: последний шаг — ровно до неё
    if (Math.abs(this.speed) >= Math.abs(gap) || Math.abs(gap) < 0.5) {
      this.position += gap;
      this.speed = 0;
    } else this.position += this.speed;
    this.x = Math.round(this.position);
  }

  reset(state: MatchState): void {
    this.position = this.target(state);
    this.x = this.position;
    this.speed = 0;
  }
}
